import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatProgressBarModule,
  MatRadioModule,
  MatSelectModule
} from '@angular/material';
import { McticRadioButtonModule, McticValidationModule } from '@mctic/ng-core';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxMaskModule } from 'ngx-mask';
import { DirectiveModule } from '../directive';
import {
  AnaliseGrupoJustificativaComponent
} from './analise-grupo-justificativa/analise-grupo-justificativa.component';
import { AutocompletePosicaoNcmComponent } from './autocomplete-classificacao/autocomplete-posicao-ncm.component';
import {
  AutocompleteEmpresaPleitoCnpjComponent
} from './autocomplete-empresa-pleito-cnpj/autocomplete-empresa-pleito-cnpj.component';
import {
  AutocompleteEmpresaPleitoComponent
} from './autocomplete-empresa-pleito/autocomplete-empresa-pleito.component';
import { AutocompleteEmpresaComponent } from './autocomplete-empresa/autocomplete-empresa.component';
import { AutocompleteProdutoComponent } from './autocomplete-produto/autocomplete-produto.component';
import { BtnCancelarComponent } from './btn-cancelar/btn-cancelar.component';
import { CurrencyMComponent } from './currency/currency-m.component';
import { CurrencyComponent } from './currency/currency.component';
import { DatepickerMesAnoComponent } from './datepicker-mes-ano/datepicker-mes-ano.component';
import { DatePickerYear } from './datepicker-year/datepicker-year.component';
import { InputFileComponent } from './file-input/input-file.component';
import { ImportarCsvComponent } from './importar-csv/importar-csv.component';
import { InfoEntidadeComponent } from './info-entidade/info-entidade.component';
import { InputCnpjComponent } from './input-cnpj/input-cnpj.component';
import { PercentComponent } from './percent/percent.component';
import { PortariaSelectComponent } from './portaria/portaria-select.component';
import { SimNaoRadioButtonComponent } from './sim-nao/sim-nao-radio-button.component';
import { TipoClasseSelectComponent } from './tipo-classe/tipo-classe-select.component';
import { OrigemTecnologiaRadioComponent } from './tipo-origem-tecnologia/origem-tecnologia-radio.component';
import { TipoProjetoSelectComponent } from './tipo-projeto/tipo-projeto-select.component';
@NgModule({
  declarations: [
    SimNaoRadioButtonComponent,
    TipoProjetoSelectComponent,
    TipoClasseSelectComponent,
    PortariaSelectComponent,
    CurrencyComponent,
    CurrencyMComponent,
    PercentComponent,
    DatePickerYear,
    InputFileComponent,
    ImportarCsvComponent,
    OrigemTecnologiaRadioComponent,
    InputCnpjComponent,
    AutocompletePosicaoNcmComponent,
    AutocompleteProdutoComponent,
    AutocompleteEmpresaComponent,
    AutocompleteEmpresaPleitoComponent,
    AutocompleteEmpresaPleitoCnpjComponent,
    DatepickerMesAnoComponent,
    AnaliseGrupoJustificativaComponent,
    BtnCancelarComponent,
    InfoEntidadeComponent
  ],
  exports: [
    SimNaoRadioButtonComponent,
    TipoProjetoSelectComponent,
    TipoClasseSelectComponent,
    PortariaSelectComponent,
    CurrencyComponent,
    CurrencyMComponent,
    DatePickerYear,
    PercentComponent,
    McticRadioButtonModule,
    CurrencyMaskModule,
    InputFileComponent,
    ImportarCsvComponent,
    OrigemTecnologiaRadioComponent,
    InputCnpjComponent,
    AutocompletePosicaoNcmComponent,
    AutocompleteProdutoComponent,
    AutocompleteEmpresaComponent,
    AutocompleteEmpresaPleitoComponent,
    AutocompleteEmpresaPleitoCnpjComponent,
    DatepickerMesAnoComponent,
    BtnCancelarComponent,
    InfoEntidadeComponent
  ],
  imports: [
    CommonModule,
    CurrencyMaskModule,
    NgxMaskModule.forChild(),
    ReactiveFormsModule,
    McticValidationModule,
    McticRadioButtonModule,
    DirectiveModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatProgressBarModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatDialogModule
  ],
  entryComponents: [AnaliseGrupoJustificativaComponent]
})
export class UIModule {
}
